import { useEffect } from 'react';

/**
 * Locks the scroll of the document body.
 * Most useful for modals or other dialogs that should disable other scrolling in the page while open.
 */

export const useScrollLock = (shouldLock: boolean) => {
  useEffect(() => {
    if (shouldLock) {
      const previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = previousOverflow;
      };
    }
  }, [shouldLock]);
};
